// create the global Sunergo namespace
window.SunergoPlatform = {
	onLoad: [],
	inputEvents: ['change', 'keyup', 'input', 'paste']
};